import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setSessionFromTokens } from "../../../cognito/cognitoTest";
import { logout, getUser } from "../../../store/actions";
import { useAppDispatch } from "../../../store/hooks";

const AuthHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('accessToken');
    const idToken = queryParams.get('idToken');
    const refreshToken = queryParams.get('refreshToken');
    const mode = queryParams.get('mode');

    if (accessToken && idToken && refreshToken) {
      setSessionFromTokens({accessToken,idToken,refreshToken})
      if(mode === 'shopify'){
      navigate('/platform/dashboard/shopify-prices-page')
      } else {
        navigate('/')
      };
    } else {
      console.error('Missing access tokens in URL');
      dispatch(logout(true));
    }
  }, []);

  return (
    <div>
      <p>Processing your login...</p>
    </div>
  );
};

export default AuthHandler;
